import ThankyouPage from "./ThankyouPage";
export default ThankyouPage;
